import AddPatient from './AddPatient'
import ImportPatient from './ImportPatient'
import UploadQuestionnaire from './UploadQuestionnaire'
import ResolveImportErrors from './ResolveImportErrors'
export default [
	{
		path: '/add/patient',
		component: AddPatient
	},
	{
		path: '/add/questionnaire',
		component: UploadQuestionnaire
	},
	{
		path: '/import',
		component: ImportPatient
	},
	{
		path: '/import/errors',
		component: ResolveImportErrors
	}
]
